import { defineAsyncComponent } from 'vue'
export default {
  "default-amp": defineAsyncComponent(() => import("/builds/devhacker/burninghut/bh-frontend/layouts/default.amp.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/devhacker/burninghut/bh-frontend/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/builds/devhacker/burninghut/bh-frontend/layouts/empty.vue").then(m => m.default || m)),
  promo: defineAsyncComponent(() => import("/builds/devhacker/burninghut/bh-frontend/layouts/promo.vue").then(m => m.default || m))
}